module.exports = __webpack_public_path__ + "img/howCloud.1e952bf5.png";